import { type ComponentRef, forwardRef } from "react";
import {
	PlateElement,
	type PlateElementProps,
} from "@platejs/core/react";
import { useTableElement, useTableColSizes } from "@platejs/table/react";

export const TableElement = forwardRef<
	ComponentRef<typeof PlateElement>,
	PlateElementProps
>(({ children, ...props }, ref) => {
	const { props: tableProps, marginLeft } = useTableElement();
	const colSizes = useTableColSizes();

	return (
		<div style={{ paddingLeft: marginLeft }}>
			<PlateElement as="table" ref={ref} {...tableProps} {...props}>
				<colgroup>
					{colSizes.map((width, index) => (
						<col key={index} style={{ width }} />
					))}
					<tbody>{children}</tbody>
				</colgroup>
			</PlateElement>
		</div>
	);
});

TableElement.displayName = "TableElement";
